import { useDevices } from '@yudiel/react-qr-scanner';
import { useCallback, useEffect, useRef, useState } from "react";
import { Alert } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import Button from "./Button";
import { DefaultButton } from "./DefaultButton";
import { Col, Row } from "./Grid";
import Icon from "./Icon";
import Select from "./Select";
import { Modal } from '../utils/dialogUtlities';

const ImageCaptureDialog = ({ onClose }) => {
    const { t } = useTranslation();
    const videoRef = useRef();
    const videoDevices = useDevices();
    const [activeDevice, setActiveDevice] = useState();
    const [error,setError] = useState();

    const startStream = useCallback(async (deviceId) => {
        try {
            const constraints = {
                video: deviceId ? { deviceId: { exact: deviceId } } : true,
                audio: false
            };
            const stream = await navigator.mediaDevices.getUserMedia(constraints);
            videoRef.current.srcObject = stream;
            setActiveDevice(stream.getVideoTracks().find(track => track.readyState === 'live')?.getSettings()?.deviceId);
        } catch (err) {
            if (err.name === 'NotAllowedError') {
                setError('You have not permitted Chronicler to access your webcam - please consult your browser documentation to enable camera support');
            } else if (err.name === 'NotFoundError') {
                setError('No devices were found from which to capture an image');
            } else {
                setError('An error occurred trying to acquire the camera video source (error details: ' + err.name + ' - ' + err.message + ')');
            }
        }
    }, []);

    const changeStream = useCallback(async (deviceId) => {
        if (videoRef.current.srcObject) {
            videoRef.current.srcObject.getTracks().forEach(track => track.stop());
        }
        if (deviceId) {
            await startStream(deviceId)
        } else {
            videoRef.current.srcObject = null;
            setActiveDevice();
        }
    }, [startStream]);

    useEffect(() => {
        startStream()
    }, [startStream])

    const doCapture = () => {
        const canvas = document.createElement('canvas');
        canvas.style.display = 'none';
        canvas.width = videoRef.current.offsetWidth;
        canvas.height = videoRef.current.offsetHeight;
        document.body.appendChild(canvas);
        const ctx = canvas.getContext('2d');
        ctx.drawImage(videoRef.current, 0, 0, canvas.width, canvas.height);
        const dataURL = canvas.toDataURL('image/png');
        document.body.removeChild(canvas);
        doClose({ data: dataURL });
    }

    const doClose = (result) => {
        if (!error && videoRef.current?.srcObject) {
            changeStream();
        }
        onClose(result);
    }

    return <Modal size="lg" show={true}>
        <Modal.Header>

        </Modal.Header>
        <Modal.Body style={{textAlign: 'center'}}>
            { videoDevices?.length > 1 && <Row className="mb-2 text-left">
                <Col>
                    <Select value={activeDevice} options={videoDevices} placeholder={t('source')} labelField="label" valueField="deviceId" onChange={id => startStream(id)}></Select>
                </Col>
            </Row>}
            <Row>
                <Col>
                {error ? <Alert>{error}</Alert> : <video className="w-100" ref={videoRef} autoPlay></video>}
                </Col>
            </Row>
        </Modal.Body>
        <Modal.Footer>
            {error ? null : <Button variant="primary" onClick={doCapture}><Icon variant="solid" kind="camera"></Icon> {t('takeImage')}</Button> }
            <DefaultButton kind="close" onClick={() => doClose(null)}></DefaultButton>
        </Modal.Footer>
    </Modal>
}

export default ImageCaptureDialog;